import { render, staticRenderFns } from "./absenteeism.vue?vue&type=template&id=1967f2db"
import script from "./absenteeism.vue?vue&type=script&lang=js"
export * from "./absenteeism.vue?vue&type=script&lang=js"
import style0 from "./absenteeism.vue?vue&type=style&index=0&id=1967f2db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports